module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tr columns"
  }, [_c('span', {
    staticClass: "delete-cell"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteServiceRequest(_vm.request.id)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "name column"
  }, [_vm._v(_vm._s(_vm.request.name))]), _vm._v(" "), _c('span', {
    staticClass: "phone column"
  }, [_c('strong', [_vm._v("Телефон: ")]), _c('br'), _vm._v(_vm._s(_vm.request.phone) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("email: ")]), _c('br'), _vm._v(_vm._s(_vm.request.email) + " "), _c('br'), _vm._v(" "), (_vm.request.city) ? _c('div', [_c('strong', [_vm._v("Город: ")]), _c('br'), _vm._v(_vm._s(_vm.request.city) + " "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "file column"
  }, [_vm._v(_vm._s(_vm.request.TINNumber))]), _vm._v(" "), _c('span', {
    staticClass: "column"
  }, [_c('span', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": _vm.request.file,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.formatedFileName))])])]), _vm._v(" "), _c('span', {
    staticClass: "column"
  }, [_c('b-switch', {
    on: {
      "change": function($event) {
        return _vm.updateServiceRequest(_vm.request)
      }
    },
    model: {
      value: (_vm.request.isProcessed),
      callback: function($$v) {
        _vm.$set(_vm.request, "isProcessed", $$v)
      },
      expression: "request.isProcessed"
    }
  }, [_vm._v("Обработан")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.request.created_at)))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ff6c2e5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ServiceRequests/ServiceRequestItem.vue
// module id = 954
// module chunks = 0